import { cva } from 'class-variance-authority';

export const mainButtonVariants = cva(
  'relative cursor-pointer disabled:bg-disabled h-12 px-8 inline-flex items-center justify-center whitespace-nowrap rounded-sm font-semibold leading-4 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-brand text-white hover:bg-brand/90',
        outlined: 'bg-light-gray hover:bg-light-gray/50 text-brand',
        alert: 'bg-alert text-white hover:bg-alert/90',
      },
      size: {
        default: '',
        fullWidth: 'w-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
